export default __webpack_public_path__ + "static/media/character-goro.d16cca00.png";